import { useEffect, useState } from 'react'
import CasinoHomeNav from './CasinoHomeNav'
import { useDispatch, useSelector } from 'react-redux';
import { selectDomainID } from '../../../AsianExchangeSrc/utils/helper/commonSelectors';
import { updateCasinoSlice } from '../../../AsianExchangeSrc/redux/slices/casinoSlice';
import axios from 'axios';

function CasinoHome() {
  const dispatch = useDispatch();
  const domainId = useSelector(selectDomainID());
  const casinoApiData = useSelector((state) => state.casino.casinoApiData);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!domainId) {
      setIsLoading(false);
      return;
    }

    // If casinoApiData already exists in Redux, use it and skip the API call
    if (casinoApiData && casinoApiData.length > 0) {
      setIsLoading(false);
      return;
    }

    // Otherwise, fetch the data
    const fetchCasino = async () => {
      setIsLoading(true);
      try {
        const response = await axios.get(
          `https://api.asianexchange.club/api/int/getIntCasinos?domainId=${domainId}`
        );
        const data = response?.data || [];
        // Store the raw API data in Redux
        dispatch(updateCasinoSlice({ casinoApiData: data }));
      } catch (error) {
        console.error("Error fetching casino data:", error);
        // toast.error("Failed to fetch casino data.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchCasino();
  }, [domainId, dispatch]);
  console.error({ casinoApiData });

  return (

    <CasinoHomeNav providerList={[...(Array.isArray(casinoApiData) ? casinoApiData: [])]} />

  )
}

export default CasinoHome